module.exports = __webpack_public_path__ + "static/img/pico21.ab91230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico21.png
// module id = rzrJ
// module chunks = 0